/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDeptsController', DinghyEventDeptsController);

    DinghyEventDeptsController.$inject = ['entity', '$state', '$http', '$stateParams'];

    function DinghyEventDeptsController(entity, $state, $http, $stateParams) {
        var vm = this;
        vm.dinghyEvent = entity;

        vm.dataExport = dataExport;
        vm.abs = abs;
        vm.depts = [];

        $http.get('api/board/dinghy-events/depts', {
            params: {
                eventId: entity.id
            }
        }).then(function (response) {
            vm.depts = response.data;
        });

        // could be replaced with vm.dinghyEvent.bookedPlaces but this way it gets refreshed every time (not only with event reload)
        $http.get('api/board/dinghy-bookings/summary', {
            params: {
                eventId: entity.id
            }
        }).then(function(response) {
            vm.status = response.data;
            vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
            vm.freePlaces = vm.dinghyEvent.placeCount - vm.validPlaces;
        });

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/dinghy-events/export/', {
                params: {
                    eventId: $stateParams.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            }).catch(function () {
                vm.isSaving = false;
            });
        }

        function abs(data) {
            return Math.abs(data);
        }
    }
})();
